import ReactGA from 'react-ga4';
export const initGA = () => {
  ReactGA.initialize('G-C52Z2JCWZJ'); 
};

export const logEvent = (eventName, parameters) => {
    ReactGA.event(eventName, parameters);
  };
